import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Atom, Boxes, HelpCircle, Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getTheme, toggleTheme } from '@/lib/theme';

export function AppHeader() {
  const [theme, setTheme] = useState(getTheme());

  return (
    <header className="flex items-center gap-3 border-b border-border bg-card px-6 py-3">
      <Link to="/" className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-violet-600 text-white">
          <Atom className="h-5 w-5" />
        </span>
        <span className="leading-tight">
          <span className="block text-sm font-semibold">Liquid Content Simulator</span>
          <span className="block text-xs text-muted-foreground">News atoms for Story Engine</span>
        </span>
      </Link>
      <div className="flex-1" />
      <Button asChild variant="ghost" size="sm">
        <Link to="/schema">
          <Boxes className="mr-1.5 h-4 w-4" />
          Atom schema
        </Link>
      </Button>
      <Button asChild variant="ghost" size="sm">
        <Link to="/how-it-works">
          <HelpCircle className="mr-1.5 h-4 w-4" />
          How this works
        </Link>
      </Button>
      <Button variant="ghost" size="icon" aria-label="Toggle theme" onClick={() => setTheme(toggleTheme())}>
        {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
    </header>
  );
}
